// import React, { useState, useEffect } from 'react';
// import Loader from '../views/material-kit/loader/Loader';

// function PayrollTable() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [selectedEmployee, setSelectedEmployee] = useState(null); // Track single selected employee
//   const [showEarningsForm, setShowEarningsForm] = useState(false);
//   const [showDeductionsForm, setShowDeductionsForm] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' }); // For success/failure messages

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = () => {
//     setLoading(true);
//     fetch('http://localhost:8000/payroll') // Replace with your API URL
//       .then((response) => response.json())
//       .then((data) => {
//         setData(data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Error fetching payroll data:', error);
//         setLoading(false);
//       });
//   };

//   const handleCheckboxChange = (employeeId, email) => {
//     if (selectedEmployee?.Employee_ID === employeeId) {
//       // Deselect if the same row is clicked again
//       setSelectedEmployee(null);
//       setShowEarningsForm(false); // Close the earnings form
//       setShowDeductionsForm(false); // Close the deductions form
//     } else {
//       // Select the new row
//       setSelectedEmployee({ Employee_ID: employeeId, Email: email });
//       setShowEarningsForm(false); // Close the earnings form
//       setShowDeductionsForm(false); // Close the deductions form
//     }
//   };

//   const handleEarningsButtonClick = () => {
//     setShowEarningsForm(true);
//     setShowDeductionsForm(false); // Ensure only one form is open at a time
//   };

//   const handleDeductionsButtonClick = () => {
//     setShowDeductionsForm(true);
//     setShowEarningsForm(false); // Ensure only one form is open at a time
//   };

//   const handleEarningsFormSubmit = (updatedEarnings) => {
//     const payload = {
//       email: selectedEmployee.Email,
//       ...updatedEarnings,
//     };
//     console.log('Earnings Payload:', payload);
//     // Call API to update earnings
//     fetch('http://localhost:8000/add_payroll', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(payload),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log('Success:', data);
//         setMessage({ type: 'success', text: 'Earnings updated successfully!' });
//         setShowEarningsForm(false);
//         fetchData(); // Refresh data
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//         setMessage({ type: 'error', text: 'Failed to update earnings. Please try again.' });
//       });
//   };

//   const handleDeductionsFormSubmit = (updatedDeductions) => {
//     const payload = {
//       email: selectedEmployee.Email,
//       ...updatedDeductions,
//     };
//     console.log('Deductions Payload:', payload);
//     // Call API to update deductions
//     fetch('http://localhost:8000/add_payroll', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(payload),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log('Success:', data);
//         setMessage({ type: 'success', text: 'Deductions updated successfully!' });
//         setShowDeductionsForm(false);
//         fetchData(); // Refresh data
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//         setMessage({ type: 'error', text: 'Failed to update deductions. Please try again.' });
//       });
//   };

//   // Pagination Logic
//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentEntries = data.slice(indexOfFirstEntry, indexOfLastEntry);

//   const totalPages = Math.ceil(data.length / entriesPerPage);

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleEntriesPerPageChange = (event) => {
//     setEntriesPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };

//   return (
//     <div style={containerStyle}>
//       <h1 style={headerStyle}>Employee Payroll Details</h1>

//       {/* Success/Failure Message */}
//       {message.text && (
//         <div style={message.type === 'success' ? successMessageStyle : errorMessageStyle}>
//           {message.text}
//         </div>
//       )}

//       {/* Entries Per Page Dropdown */}
//       <div style={entriesPerPageStyle}>
//         <label>
//           Show{' '}
//           <select value={entriesPerPage} onChange={handleEntriesPerPageChange}>
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={20}>20</option>
//             <option value={50}>50</option>
//           </select>{' '}
//           entries
//         </label>
//       </div>

//       <div style={tableContainerStyle}>
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={headerCellStyle}>Select</th>
//               <th style={headerCellStyle}>Employee ID</th>
//               <th style={headerCellStyle}>Name</th>
//               <th style={headerCellStyle}>Email</th>
//               <th style={headerCellStyle}>Basic</th>
//               <th style={headerCellStyle}>HRA</th>
//               <th style={headerCellStyle}>Personal Allowance</th>
//               <th style={headerCellStyle}>Appreciation Bonus</th>
//               <th style={headerCellStyle}>TDS</th>
//               <th style={headerCellStyle}>LOP</th>
//               <th style={headerCellStyle}>Professional Tax</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentEntries.map((row) => (
//               <tr key={row.Employee_ID} style={tableRowStyle}>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedEmployee?.Employee_ID === row.Employee_ID}
//                     onChange={() => handleCheckboxChange(row.Employee_ID, row.Email)}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>{row.Employee_ID}</td>
//                 <td style={tableCellStyle}>{row.first_name} {row.last_name}</td>
//                 <td style={tableCellStyle}>{row.Email}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.earnings.Basic}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.earnings.HRA}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.earnings.PersonalAllowance}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.earnings.AppreciationBonus}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.deductions.TDS}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.deductions.LOP}</td>
//                 <td style={tableCellStyle}>{row.Payroll_Details.deductions.ProfessionalTax}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Controls */}
//       <div style={paginationStyle}>
//         <button onClick={handlePreviousPage} disabled={currentPage === 1} style={paginationButtonStyle}>
//           Previous
//         </button>
//         <span style={pageInfoStyle}>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button onClick={handleNextPage} disabled={currentPage === totalPages} style={paginationButtonStyle}>
//           Next
//         </button>
//       </div>

//       {/* Earnings and Deductions Buttons */}
//       {selectedEmployee && (
//         <div style={buttonContainerStyle}>
//           <button onClick={handleEarningsButtonClick} style={earningsButtonStyle}>
//             Update Earnings
//           </button>
//           <button onClick={handleDeductionsButtonClick} style={deductionsButtonStyle}>
//             Update Deductions
//           </button>
//         </div>
//       )}

//       {/* Earnings Form */}
//       {showEarningsForm && (
//         <EarningsForm
//           onSubmit={handleEarningsFormSubmit}
//           onCancel={() => setShowEarningsForm(false)}
//           initialValues={data.find((row) => row.Email === selectedEmployee.Email)?.Payroll_Details.earnings}
//         />
//       )}

//       {/* Deductions Form */}
//       {showDeductionsForm && (
//         <DeductionsForm
//           onSubmit={handleDeductionsFormSubmit}
//           onCancel={() => setShowDeductionsForm(false)}
//           initialValues={data.find((row) => row.Email === selectedEmployee.Email)?.Payroll_Details.deductions}
//         />
//       )}
//     </div>
//   );
// }

// // Earnings Form Component
// const EarningsForm = ({ onSubmit, onCancel, initialValues }) => {
//   const [basic, setBasic] = useState(initialValues?.Basic || 0);
//   const [hra, setHRA] = useState(initialValues?.HRA || 0);
//   const [personalAllowance, setPersonalAllowance] = useState(initialValues?.PersonalAllowance || 0);
//   const [appreciationBonus, setAppreciationBonus] = useState(initialValues?.AppreciationBonus || 0);

//   // Update form values when initialValues change
//   useEffect(() => {
//     setBasic(initialValues?.Basic || 0);
//     setHRA(initialValues?.HRA || 0);
//     setPersonalAllowance(initialValues?.PersonalAllowance || 0);
//     setAppreciationBonus(initialValues?.AppreciationBonus || 0);
//   }, [initialValues]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const updatedEarnings = {
//       Basic: basic,
//       HRA: hra,
//       PersonalAllowance: personalAllowance,
//       AppreciationBonus: appreciationBonus,
//     };
//     onSubmit(updatedEarnings);
//   };

//   return (
//     <div style={formContainerStyle}>
//       <h2 style={formHeaderStyle}>Update Earnings</h2>
//       <form onSubmit={handleSubmit} style={formStyle}>

//         <div  style={formGridStyle}>  
//         <label  style={formLabelStyle}>
//           Basic:
//           <input
//             type="number"
//             value={basic}
//             onChange={(e) => setBasic(e.target.value)}
//             style={inputStyle}
//           />
//         </label>
//         <label     style={formLabelStyle}>
//           HRA:
//           <input
//             type="number"
//             value={hra}
//             onChange={(e) => setHRA(e.target.value)}
//             style={inputStyle}
         
//           />
//         </label>
//         <label     style={formLabelStyle}>
//           Personal Allowance:
//           <input
//             type="number"
//             value={personalAllowance}
//             onChange={(e) => setPersonalAllowance(e.target.value)}
//             style={inputStyle}
//           />
//         </label>
//         <label     style={formLabelStyle}>
//           Appreciation Bonus:
//           <input
//             type="number"
//             value={appreciationBonus}
//             onChange={(e) => setAppreciationBonus(e.target.value)}
//             style={inputStyle}
//           />
//         </label>


//         </div>
//         <div style={formButtonContainerStyle}>
//           <button type="submit" style={submitButtonStyle}>Submit</button>
//           <button type="button" onClick={onCancel} style={cancelButtonStyle}>Cancel</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// // Deductions Form Component
// const DeductionsForm = ({ onSubmit, onCancel, initialValues }) => {
//   const [tds, setTDS] = useState(initialValues?.TDS || 0);
//   const [lop, setLOP] = useState(initialValues?.LOP || 0);
//   const [professionalTax, setProfessionalTax] = useState(initialValues?.ProfessionalTax || 0);

//   // Update form values when initialValues change
//   useEffect(() => {
//     setTDS(initialValues?.TDS || 0);
//     setLOP(initialValues?.LOP || 0);
//     setProfessionalTax(initialValues?.ProfessionalTax || 0);
//   }, [initialValues]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const updatedDeductions = {
//       TDS: tds,
//       LOP: lop,
//       ProfessionalTax: professionalTax,
//     };
//     onSubmit(updatedDeductions);
//   };

//   return (
    
//     <div style={formContainerStyle}>
//       <h2  style={formHeaderStyle} >Update Deductions</h2>
//       <form onSubmit={handleSubmit} style={formStyle}>

//         <div style={formGridStyle}> 
//         <label style={formLabelStyle}>
//           TDS:
//           <input
//             type="number"
//             value={tds}
//             onChange={(e) => setTDS(e.target.value)}
//             style={inputStyle}
//           />
//         </label>
//         <label style={formLabelStyle}>
//           LOP:
//           <input
//             type="number"
//             value={lop}
//             onChange={(e) => setLOP(e.target.value)}
//             style={inputStyle}
//           />
//         </label>
//         <label style={formLabelStyle}>
//           Professional Tax:
//           <input
//             type="number"
//             value={professionalTax}
//             onChange={(e) => setProfessionalTax(e.target.value)}
//             style={inputStyle}
//           />
//         </label>

//         </div>
//         <div style={formButtonContainerStyle}>
//           <button type="submit" style={submitButtonStyle}>Submit</button>
//           <button type="button" onClick={onCancel} style={cancelButtonStyle}>Cancel</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// // Styles (same as before)
// const containerStyle = {
//   fontFamily: 'Arial, sans-serif',
//   padding: '20px',
//   backgroundColor: '#f9f9f9',
//   color: 'black',
// };

// const headerStyle = {
//   textAlign: 'center',
//   marginBottom: '20px',
//   color: '#333',
// };

// const entriesPerPageStyle = {
//   marginBottom: '20px',
//   textAlign: 'right',
// };

// const tableContainerStyle = {
//   overflowX: 'auto',
// };

// const tableStyle = {
//   borderCollapse: 'collapse',
//   width: '100%',
//   marginTop: '20px',
//   boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//   backgroundColor: '#fff',
// };

// const headerCellStyle = {
//   backgroundColor: '#007BFF',
//   color: '#fff',
//   padding: '12px',
//   textAlign: 'left',
//   fontWeight: 'bold',
// };

// const tableRowStyle = {
//   borderBottom: '1px solid #ddd',
// };

// const tableCellStyle = {
//   border: '1px solid #ddd',
//   padding: '12px',
//   textAlign: 'left',
// };

// const paginationStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   marginTop: '20px',
// };

// const paginationButtonStyle = {
//   padding: '10px 20px',
//   borderRadius: '5px',
//   backgroundColor: '#007BFF',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer',
//   margin: '0 10px',
// };

// const pageInfoStyle = {
//   margin: '0 10px',
//   fontSize: '16px',
// };

// const buttonContainerStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   marginTop: '20px',
//   marginBottom:"30px"
// };

// const earningsButtonStyle = {
//   padding: '10px 20px',
//   borderRadius: '5px',
//   backgroundColor: '#28a745',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer',
//   margin: '0 10px',
// };

// const deductionsButtonStyle = {
//   padding: '10px 20px',
//   borderRadius: '5px',
//   backgroundColor: '#dc3545',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer',
//   margin: '0 10px',
// };

// const formContainerStyle = {
//     marginTop: '100px',
//     padding: '20px',
//     backgroundColor: '#fff',
//     borderRadius: '10px',
//     boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
//     maxWidth: '800px',
//     margin: '0 auto',
//     marginTop: '100px',
  
// };

// const formButtonContainerStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   marginTop: '20px',
// };

// const submitButtonStyle = {
//   padding: '10px 20px',
//   borderRadius: '5px',
//   backgroundColor: '#28a745',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer',
//   margin: '0 10px',
// };

// const cancelButtonStyle = {
//   padding: '10px 20px',
//   borderRadius: '5px',
//   backgroundColor: '#dc3545',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer',
//   margin: '0 10px',
// };

// const successMessageStyle = {
//   padding: '10px',
//   backgroundColor: '#d4edda',
//   color: '#155724',
//   border: '1px solid #c3e6cb',
//   borderRadius: '5px',
//   marginBottom: '20px',
//   textAlign: 'center',
// };

// const errorMessageStyle = {
//   padding: '10px',
//   backgroundColor: '#f8d7da',
//   color: '#721c24',
//   border: '1px solid #f5c6cb',
//   borderRadius: '5px',
//   marginBottom: '20px',
//   textAlign: 'center',
// };



// const formStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '20px',
//   };
  
//   const formGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//     gap: '20px',
//   };
  
//   const formLabelStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//     fontSize: '16px',
//     color: '#555',
//   };
  
//   const inputStyle = {
//     padding: '10px',
//     borderRadius: '5px',
//     border: '1px solid #ddd',
//     fontSize: '16px',
//     outline: 'none',
//     transition: 'border-color 0.3s ease',
//   };
  
//   const formHeaderStyle = {
//     textAlign: 'center',
//     marginBottom: '20px',
//     fontSize: '24px',
//     color: '#333',
//   };

// export default PayrollTable;










import React, { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa'; // Import edit icon from react-icons

function PayrollTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/payroll`)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching payroll data:', error);
        setLoading(false);
      });
  };

  const handleEditClick = (employeeId, email) => {
    setSelectedEmployee({ Employee_ID: employeeId, Email: email });
    setShowForm(true);
  };

  const handleFormSubmit = (formData) => {
    const payload = {
      email: selectedEmployee.Email,
      ...formData.earnings,
      ...formData.deductions,
    };
    fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add_payroll`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        setMessage({ type: 'success', text: 'Payroll updated successfully!' });
        setShowForm(false);
        fetchData();
      })
      .catch((error) => {
        setMessage({ type: 'error', text: 'Failed to update payroll. Please try again.' });
      });
  };

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = data.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(data.length / entriesPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Employee Payroll Details</h1>

      {message.text && (
        <div style={message.type === 'success' ? successMessageStyle : errorMessageStyle}>
          {message.text}
        </div>
      )}

      <div style={entriesPerPageStyle}>
        <label>
          Show{' '}
          <select value={entriesPerPage} onChange={handleEntriesPerPageChange}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>{' '}
          entries
        </label>
      </div>

      <div style={tableContainerStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={headerCellStyle}>Employee ID</th>
              <th style={headerCellStyle}>Name</th>
              <th style={headerCellStyle}>Email</th>
              <th style={headerCellStyle}>Basic</th>
              <th style={headerCellStyle}>HRA</th>
              <th style={headerCellStyle}>Personal Allowance</th>
              <th style={headerCellStyle}>Appreciation Bonus</th>
              <th style={headerCellStyle}>TDS</th>
              <th style={headerCellStyle}>LOP</th>
              <th style={headerCellStyle}>Professional Tax</th>
              <th style={headerCellStyle}>Edit</th>
            </tr>
          </thead>
          <tbody>
            {currentEntries.map((row) => (
              <tr key={row.Employee_ID} style={tableRowStyle}>
                <td style={tableCellStyle}>{row.Employee_ID}</td>
                <td style={tableCellStyle}>{row.first_name} {row.last_name}</td>
                <td style={tableCellStyle}>{row.Email}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.earnings.Basic}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.earnings.HRA}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.earnings.PersonalAllowance}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.earnings.AppreciationBonus}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.deductions.TDS}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.deductions.LOP}</td>
                <td style={tableCellStyle}>{row.Payroll_Details.deductions.ProfessionalTax}</td>
                <td style={tableCellStyle}>
                  <FaEdit
                    style={{ cursor: 'pointer', color: '#007BFF' }}
                    onClick={() => handleEditClick(row.Employee_ID, row.Email)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={paginationStyle}>
        <button onClick={handlePreviousPage} disabled={currentPage === 1} style={paginationButtonStyle}>
          Previous
        </button>
        <span style={pageInfoStyle}>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages} style={paginationButtonStyle}>
          Next
        </button>
      </div>

      {showForm && (
        <Modal onClose={() => setShowForm(false)}>
          <PayrollForm
            key={selectedEmployee.Employee_ID}
            onSubmit={handleFormSubmit}
            onCancel={() => setShowForm(false)}
            initialValues={data.find((row) => row.Email === selectedEmployee.Email)?.Payroll_Details}
          />
        </Modal>
      )}
    </div>
  );
}

const Modal = ({ onClose, children }) => {
  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button style={modalCloseButtonStyle} onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

const PayrollForm = ({ onSubmit, onCancel, initialValues }) => {
  const [formData, setFormData] = useState({
    earnings: {
      Basic: initialValues?.earnings?.Basic || 0,
      HRA: initialValues?.earnings?.HRA || 0,
      PersonalAllowance: initialValues?.earnings?.PersonalAllowance || 0,
      AppreciationBonus: initialValues?.earnings?.AppreciationBonus || 0,
    },
    deductions: {
      TDS: initialValues?.deductions?.TDS || 0,
      LOP: initialValues?.deductions?.LOP || 0,
      ProfessionalTax: initialValues?.deductions?.ProfessionalTax || 0,
    },
  });

  const handleChange = (e, category, field) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        [field]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div style={formContainerStyle}>
      <h2 style={formHeaderStyle}>Update Payroll</h2>
      <form onSubmit={handleSubmit} style={formStyle}>
        <div style={formGridStyle}>
          {Object.entries(formData.earnings).map(([key, value]) => (
            <label key={key} style={formLabelStyle}>
              {key}:
              <input
                type="number"
                value={value}
                onChange={(e) => handleChange(e, 'earnings', key)}
                style={inputStyle}
              />
            </label>
          ))}
          {Object.entries(formData.deductions).map(([key, value]) => (
            <label key={key} style={formLabelStyle}>
              {key}:
              <input
                type="number"
                value={value}
                onChange={(e) => handleChange(e, 'deductions', key)}
                style={inputStyle}
              />
            </label>
          ))}
        </div>
        <div style={formButtonContainerStyle}>
          <button type="submit" style={submitButtonStyle}>Save</button>
          <button type="button" onClick={onCancel} style={cancelButtonStyle}>Cancel</button>
        </div>
      </form>
    </div>
  );
};
// Styles
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '10px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  maxWidth: '800px',
  width: '100%',
  position: 'relative',
};

const modalCloseButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'none',
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
};

// Rest of the styles remain the same as in your original code


// Styles (same as before)
const containerStyle = {
  fontFamily: 'Arial, sans-serif',
  padding: '20px',
  backgroundColor: '#f9f9f9',
  color: 'black',
};

const headerStyle = {
  textAlign: 'center',
  marginBottom: '20px',
  color: '#333',
};

const entriesPerPageStyle = {
  marginBottom: '20px',
  textAlign: 'right',
};

const tableContainerStyle = {
  overflowX: 'auto',
};

const tableStyle = {
  borderCollapse: 'collapse',
  width: '100%',
  marginTop: '20px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
};

const headerCellStyle = {
  backgroundColor: '#007BFF',
  color: '#fff',
  padding: '12px',
  textAlign: 'left',
  fontWeight: 'bold',
};

const tableRowStyle = {
  borderBottom: '1px solid #ddd',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  padding: '12px',
  textAlign: 'left',
};

const paginationStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
};

const paginationButtonStyle = {
  padding: '10px 20px',
  borderRadius: '5px',
  backgroundColor: '#007BFF',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  margin: '0 10px',
};

const pageInfoStyle = {
  margin: '0 10px',
  fontSize: '16px',
};

const formContainerStyle = {
  marginTop: '100px',
  padding: '20px',
  backgroundColor: '#fff',
  borderRadius: '10px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  maxWidth: '800px',
  margin: '0 auto',
  marginTop: '100px',
};

const formButtonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
};

const submitButtonStyle = {
  padding: '10px 20px',
  borderRadius: '5px',
  backgroundColor: '#28a745',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  margin: '0 10px',
};

const cancelButtonStyle = {
  padding: '10px 20px',
  borderRadius: '5px',
  backgroundColor: '#dc3545',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  margin: '0 10px',
};

const successMessageStyle = {
  padding: '10px',
  backgroundColor: '#d4edda',
  color: '#155724',
  border: '1px solid #c3e6cb',
  borderRadius: '5px',
  marginBottom: '20px',
  textAlign: 'center',
};

const errorMessageStyle = {
  padding: '10px',
  backgroundColor: '#f8d7da',
  color: '#721c24',
  border: '1px solid #f5c6cb',
  borderRadius: '5px',
  marginBottom: '20px',
  textAlign: 'center',
};

const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

const formGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '20px',
};

const formLabelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  fontSize: '16px',
  color: '#555',
};

const inputStyle = {
  padding: '10px',
  borderRadius: '5px',
  border: '1px solid #ddd',
  fontSize: '16px',
  outline: 'none',
  transition: 'border-color 0.3s ease',
};

const formHeaderStyle = {
  textAlign: 'center',
  marginBottom: '20px',
  fontSize: '24px',
  color: '#333',
};

export default PayrollTable;